export default {

  props: {
    imageCollection: { type: Object /*ImageCollection*/, required: true },
    fill: { type: Boolean, default: true },
    center: { type: Boolean, default: true },
  },

  data() {
    return {
      hasMounted: false,
    }
  },

  computed: {
    imageDefaultClasses() {
      return 'new-layer'
    },
  },

  render (h) {

    if(this.imageCollection == null || this.imageCollection.isEmpty) return

    // Render a temporary hidden image, so we can get a measurement after it has been mounted
    if(this.hasMounted == false) return h('n-image', {
      props: {fill: this.fill, center: this.center},
      class: this.imageDefaultClasses,
      style: 'visibility: hidden;'
    })

    const image = this.imageCollection.createFitImage(this.$el.offsetWidth, this.$el.offsetHeight)

    return h('n-image', {
      props: { src: image.path, fill: this.fill, center: this.center },
      class: this.imageDefaultClasses,
      attrs: this.$attrs,
    })

    // Debug mode
    /*return h('div', {}, [
      h('n-image', {
        props: { src: image.path },
        attrs: this.$attrs,
      }),
      h('h6', {class: 'new-layer flexbox align-center justify-center white--text'}, image.isLandscape ? 'landscape' : 'portrait')
    ])*/

  },

  mounted() {
    this.$nextTick(() => this.hasMounted = true)
  }
}
